<script setup lang="ts">
import TruncateText from '@/components/TruncateText.vue';
import { joinAll } from '@/lib/tools';
import type { RoCrate } from '@/services/api';

const { license } = defineProps<{
  license: NonNullable<RoCrate['license']>;
}>();

const localLicense = license[0];

if (!localLicense) {
  console.warn('🪚 WHY: No license');
  throw new Error('No License');
}
</script>

<template>
  <div class="flex flex-col gap-8 p-4 items-center">
    <a class="underline" :href="localLicense['@id']" target="_blank">
      {{ joinAll(localLicense.name) }}
    </a>

    <TruncateText v-if="localLicense.description" :text="joinAll(localLicense.description, '\n\n')" :lines="2" />
  </div>
</template>
